export const RouteKeys = {
  InitialRegistration: {title: 'Início Cadastro', value: '/inicio-cadastro'},
  DataRegistration: {title: 'Dados Cadastrais', value: '/dados-cadastrais'},
  EndDataRegistration: {
    title: 'Finalizar Dados Cadastrais',
    value: '/finalizar-dados-cadastrais',
  },
  PhotoTime: {title: 'Hora Da Foto', value: '/hora-da-foto'},
  DocumentTime: {title: 'Hora Do Documento', value: '/hora-do-documento'},
  DocumentVerse: {title: 'Verso Do Documento', value: '/verso-do-documento'},
  DataResidential: {
    title: 'Dados Residenciais',
    value: '/dados-residenciais',
  },
  DataDocument: {title: 'Dados Documento', value: '/dados-documento'},
  DataProfessional: {
    title: 'Dados Profissionais',
    value: '/dados-profissionais',
  },
  DataContact: {title: 'Dados Contato', value: '/dados-contato'},
  CodeExpired: {title: 'Código Expirado', value: '/codigo-expirado'},
  IntermediateReturn: {
    title: 'Intermediar Retorno',
    value: '/intermediar-retorno',
  },
  SignatureExample: {
    title: 'Assinatura Exemplo',
    value: '/assinatura-exemplo',
  },
  Signature: {title: 'Assinatura', value: '/assinatura'},
  YourCard: {title: 'Seu Cartão', value: '/seu-cartao'},
  AdditionalCard: {title: 'Cartão Adicional', value: '/cartao-adicional'},
  SignatureNotFound: {
    title: 'Assinatura Não Encontrada',
    value: '/assinatura-nao-encontrada',
  },
  LinkResendedSucess: {
    title: 'Link Reenviado Sucesso',
    value: '/link-reenviado-sucesso',
  },
  ProposalSendSucess: {
    title: 'Proposta Enviada Sucesso',
    value: '/proposta-enviada-sucesso',
  },
  ConfirmYourPicture: {
    title: 'Confirme Sua Foto',
    value: '/confirme-sua-foto',
  },
  TakeYourPicture: {title: 'Tire Sua Foto', value: '/tire-sua-foto'},
  TermsAccept: {title: 'Termo De Aceite', value: '/termos-de-aceite'},
  Finish: {title: 'Finalizar', value: '/finalizar'},
  ValidationAccessCode: {title: 'Validação', value: '/validacao'},
  TakeYourPictureDocument: {
    title: 'Foto Do Documento',
    value: '/foto-do-documento',
  },
  TakeYourPictureDocumentBack: {
    title: 'Foto Do Documento Verso',
    value: '/foto-do-documento-verso',
  },
  ConfirmationPhotoDocument: {
    title: 'Confirmar Foto Documento',
    value: '/confirmar-foto-documento',
  },
  ConfirmationPhotoDocumentBack: {
    title: 'Confirmar Foto Documento Verso',
    value: '/confirmar-foto-documento-verso',
  },
  ValidateCodeSms: {
    title: 'Validar Código Sms',
    value: '/validar-codigo-sms',
  },
  ConfirmPhoneSuccess: {
    title: 'Confirmar Celular Sucesso',
    value: '/confirmar-celular-sucesso',
  },
  ProcessingPreEvaluation: {
    title: 'Processando Pré Avaliação',
    value: '/processando-pre-avaliacao',
  },
  PreEvaluationCompletedSuccess: {
    title: 'Pré Avaliação Aprovada',
    value: '/pre-avaliacao-aprovada',
  },
  PreEvaluationCompletedFail: {
    title: 'Pré Avaliação Reprovada',
    value: '/pre-avaliacao-reprovada',
  },
  RemakePreEvaluation: {
    title: 'Refazer Pré Avaliação',
    value: '/refazer-pre-avaliacao',
  },
  HireInsurance: {title: 'Contratar Seguros', value: '/contratar-seguros'},
};
